<template>
  <a
    v-if="this.shouldDisplay()"
    :href="this.imageLink()"
    class="LeaderboardAd"
  >
    <img
      :src="this.imageSrc()"
      class="column is-record-ad is-hidden-mobile has-text-centered"
      alt="advertisemnt"
    >
  </a>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('advertisements', {
      ads: (state) => state.record_ads,
    }),
  },
  methods: {
    shouldDisplay() {
      return !!this.ads?.length;
    },
    imageSrc() {
      return Array.from(this.ads)[0].src;
    },
    imageLink() {
      return Array.from(this.ads)[0].link;
    },
  },
};
</script>
